<template>
  <v-footer
    dark
    height="auto"
  >
    <v-card
      flat
      tile
      width="100%"
      class="secondary lighten-1 white--text text-xs-center"
    >
      <v-flex pa-0>
        <img
                src="@/assets/img/IVE/logo_IVE_Bianco.png"
                width="100"
                height="auto"
        />
      </v-flex>
      <!--<v-card-text>
        <v-btn
          v-for="socialMedia in socialMedias"
          :key="socialMedia.icon"
          class="mx-3  white--text "
          icon
        >
          <a :href="socialMedia.href" target="_blank">
            <v-icon
              size="24px"
              color="white"
            >{{ socialMedia.icon }}</v-icon>
          </a>
        </v-btn>
      </v-card-text>-->

      <!--<v-card-text class="white--text pt-0">
        Our group deals with AI and NLP topics.
        Get connected with us on social networks!
      </v-card-text>-->

      <v-card-text>
        <v-layout row wrap class="mx-5 px-5">
          <v-flex>
            <button class="cookie-button"  @click="openPrivPol">Cookie & Privacy Policy</button>
          </v-flex>
          <v-flex>
            <button class="cookie-button" @click="openTEC">Terms & conditions</button>
          </v-flex>
        </v-layout>

      </v-card-text>



      <v-divider/>

      <v-card-text class="white--text">
        &copy; {{ new Date().getFullYear() }} — <strong>NTT DATA Italia</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>


<script>
  import RouterService from "@/helpers/RouterService";

  export default {
    name: "ContentFooter",
    data() {
        return {
            socialMedias: [
                {
                    icon: "fas fa-building",
                    href: "https://it.nttdata.com",
                },
                {
                    icon: "fab fa-facebook",
                    href: "https://www.facebook.com/nttdataitalia/",
                },
                {
                    icon: "fab fa-twitter",
                    href: "https://twitter.com/NTTDATA_IT/",
                },
                {
                    icon: "fab fa-linkedin",
                    href: "https://it.linkedin.com/company/ntt-data-italia/",
                },
            ],
        };
    },
  methods: {
    navigate(path) {
      RouterService.goTo(path);
    },
    openCookiesPolicy(){
        this.navigate("/cookie-policy");
    },
    openTEC(){
      this.navigate("/terms-conditions");
    },
    openPrivPol(){
      this.$router
          .push({ path: '/privacy-policy' })
          .then(() => { this.$router.go() });
      //this.navigate("/privacy-policy");
    }

  }
};
</script>

<style lang="scss">


  .cookie-button {
    color: white!important;
    border: none!important;
    height: auto;
    white-space: normal;
    padding: 0.8em 2em;
    font-size: 0.8em;
    line-height: 1.2;
    background-color: transparent;
    outline:none;

  }

  .cookie-button:hover {
    color: white!important;
    border: none!important;
    background-color: transparent!important;


  }

</style>

